
export const VisionTemplate = ({ visionForm }) => {
    return (
        <div className="border-t">
            <p className="p-3 font-bold text-xl border-b">Vision</p>
            <span className="font-bold pl-3 pt-3">Company Potential:</span>
            <ul className="p-3 border-dashed border-b">
                {visionForm?.companyPotential.map((el, index) => (
                    <li key={index}>{el.companyPotential}</li>
                ))}
            </ul>
            <span className="font-bold pl-3 pt-3">World Potential:</span>
            <ul className="p-3">
                {visionForm?.worldPotential}
            </ul>
        </div>
    )
}